import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerificationMarketerComponent } from './verification-marketer.component';

const routes: Routes = [
  {path: '', component: VerificationMarketerComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerificationMarketerRoutingModule { }
